import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const useIsSmall = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));

    return matches
}

export const FlexBreakSmall = () => {
    const isSmall = useIsSmall()

    return <>{isSmall && <div style={{ flexBasis: '100%', display: 'inline-block', overflow: 'hidden', width: 0, height: 0 }}></div>}</>
}
